/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const DocumentResultStatus = {
        NOT_UPLOADED: 'not_uploaded',
        IN_REVIEW: 'in_review',
        CONFIRMED: 'confirmed',
        DECLINED: 'declined',
        MANUALLY_UPLOADED: 'manually_uploaded'
} as const;
export type DocumentResultStatus = typeof DocumentResultStatus[keyof typeof DocumentResultStatus];

